import script from "./tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./tag.vue?vue&type=script&lang=ts&setup=true"

import "./tag.vue?vue&type=style&index=0&id=c1fab564&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1fab564"]])

export default __exports__